import ElementsByType from "./elements-by-type.js";

import GeometryTypeGen from "./trackers/assets/geometries/type-gen.js";
import MaterialTypeGen from "./trackers/assets/materials/type-gen.js";
import ObjectTypeGen from "./trackers/assets/objects/type-gen.js";
import EnvLightTypeGen from "./trackers/assets/envlights/type-gen.js";

import { GeometryTypes, Unrecognized as UnrecognizedGeometry } from "../data-defs/geometry-types.js";
import { MaterialFullTypes, Unrecognized as UnrecognizedMaterial } from "../data-defs/material-full-types.js";
import { ObjectTypes } from "../data-defs/object-types.js";
import { EnvLightTypes, Unrecognized as UnrecognizedEnvLight } from "../data-defs/envlight-types.js";

const GeoTypes = [UnrecognizedGeometry].concat(GeometryTypes);
const MatTypes = [UnrecognizedMaterial].concat(MaterialFullTypes);
const ObjTypes = ObjectTypes;
const EnvTypes = [UnrecognizedEnvLight].concat(EnvLightTypes);

const Types = [
    { type: "geometries", subTypes: GeoTypes, createTypeTracker: (key, evtCtx) => new GeometryTypeGen(evtCtx) },
    { type: "materials",  subTypes: MatTypes, createTypeTracker: (key, evtCtx) => new MaterialTypeGen(evtCtx) },
    { type: "objects",    subTypes: ObjTypes, createTypeTracker: (key, evtCtx) => new ObjectTypeGen(evtCtx)   },
    { type: "envLights",  subTypes: EnvTypes, createTypeTracker: (key, evtCtx) => new EnvLightTypeGen(evtCtx) },
];

class AssetsByType {
    constructor(wrapCtx, evtCtx) {
        this._elements = {};
        this._assets = {};

        for (const { type, subTypes, createTypeTracker } of Types) {
            const elements = new ElementsByType(wrapCtx, evtCtx, subTypes, (key) => createTypeTracker(key, evtCtx));
            this._elements[type] = elements;
            this._assets[type] = elements.elements;
        }

        Object.freeze(this._assets);
    }

    get assets() { return this._assets; }

    track(assetData) {
        if (assetData) {
            for (const { type } of Types) {
                this._elements[type].track(assetData[type]);
            }
        } else {
            for (const { type } of Types) {
                this._elements[type].track();
            }
        }
    }

    update() {
        for (const { type } of Types) {
            this._elements[type].update();
        }
    }
}

export default AssetsByType;
